import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export const bomItemIsPurchasingPartSelector =
  (bomItemId: string) => (state: RootAppState) => {
    const bomItem = bomItemSelector(state, bomItemId)

    switch (bomItem?.type) {
      case 'Row':
        return bomItem.isPurchasingBomItem
    }

    return false
  }
